import React from 'react';
import { Col, Container, Row } from "react-bootstrap";

const Perks = () => {
    return (
        <div className="Perks p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={10} lg={10} xl={10} xxl={10} className="m-auto text-center">
                        <h2>Perks of Collaborating with a Pioneering Startup Prototype Development Company</h2>
                        <p>Experience modernization's edge with us—a ground-breaking Startup Prototype Development Company. Team up with TekRevol for leading-edge solutions and unleash supreme advantages in development.</p>
                    </Col>
                </Row>
                <Row className="h-100 perks-padd">
                    <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                        <div className="perks-box">
                            <div className="perks-content">
                                <h4>Access to Expert <br/>Talent</h4>
                                <p>Utilize TekRevol's Startup Prototype Development to quickly tap into a diverse pool of expert professionals, perfectly aligned with the unique requirements of your projects.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-lg-5 mb-xl-0">
                        <div className="perks-box">
                            <div className="perks-content">
                                <h4>Flexibility and Cost-Efficiency</h4>
                                <p>Improve resource utilization and control costs successfully with TekRevol’s flexible Startup Prototype Development services.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                        <div className="perks-box">
                            <div className="perks-content">
                                <h4>Accelerated Project Timelines</h4>
                                <p>Experience advanced project timelines as our proficient professionals impeccably integrate into your existing team.</p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
                        <div className="perks-box">
                            <div className="perks-content">
                                <h4>Transform Challenges into Opportunities</h4>
                                <p>With the right skills at the right time, steer through complexities with confidence, launching your business towards success and accomplishing milestones resourcefully.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Perks